import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, Router } from '@angular/router';

@Component({
  selector: 'black-not-found',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './not-found.component.html',
  styles: []
})
export class NotFoundComponent implements OnInit {
  private router = inject(Router);


  ngOnInit() {
    // If we're already on the 404 page, no need to redirect
    if (this.router.url === '/404') {
      return;
    }
    
    // Redirect to 404 page
    this.router.navigate(['/404']);
  }
} 